import { render } from "./draggableMarker.vue?vue&type=template&id=2aa21db0"
import script from "./draggableMarker.vue?vue&type=script&lang=js"
export * from "./draggableMarker.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__